<template>
  <base-button class="btn-dark px-4" text="戻る" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'BackButton',
  components: {
    BaseButton,
  },
}
</script>
